import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { useMakerSignUpFormContextStore } from "@faire/retailer-visitor-shared/views/apply/MakerApplication/MakerSignUpFormStore";
import { useMakerSignUpContextStore } from "@faire/retailer-visitor-shared/views/apply/MakerApplication/MakerSignUpStore";
import { useMakerSignUp } from "@faire/retailer-visitor-shared/views/apply/MakerApplication/useMakerSignUp";
import { useMakerSignUpForm } from "@faire/retailer-visitor-shared/views/apply/MakerApplication/useMakerSignUpForm";
export var useMakerSignUpFormFields = function() {
    var _useMakerSignUpFormContextStore = _sliced_to_array(useMakerSignUpFormContextStore([
        "companyName",
        "url",
        "email",
        "categoryOption",
        "stockists",
        "numProducts",
        "urlValidationInProgress",
        "secondaryCategoryOptions"
    ]), 1), _useMakerSignUpFormContextStore_ = _useMakerSignUpFormContextStore[0], companyName = _useMakerSignUpFormContextStore_.companyName, url = _useMakerSignUpFormContextStore_.url, email = _useMakerSignUpFormContextStore_.email, categoryOption = _useMakerSignUpFormContextStore_.categoryOption, stockists = _useMakerSignUpFormContextStore_.stockists, numProducts = _useMakerSignUpFormContextStore_.numProducts, urlValidationInProgress = _useMakerSignUpFormContextStore_.urlValidationInProgress, secondaryCategoryOptions = _useMakerSignUpFormContextStore_.secondaryCategoryOptions;
    var _useMakerSignUpContextStore = _sliced_to_array(useMakerSignUpContextStore([
        "acceptedTerms"
    ]), 1), acceptedTerms = _useMakerSignUpContextStore[0].acceptedTerms;
    var _useMakerSignUpForm = useMakerSignUpForm(), countryLabel = _useMakerSignUpForm.countryLabel, onUrlBlur = _useMakerSignUpForm.onUrlBlur, errorFor = _useMakerSignUpForm.errorFor, isUrlValid = _useMakerSignUpForm.isUrlValid, onChange = _useMakerSignUpForm.onChange, onSubmit = _useMakerSignUpForm.onSubmit, brandNameEvent = _useMakerSignUpForm.brandNameEvent, setCountry = _useMakerSignUpForm.setCountry, emailEvent = _useMakerSignUpForm.emailEvent, categoryEvent = _useMakerSignUpForm.categoryEvent, setFormField = _useMakerSignUpForm.setFormField, returnEvent = _useMakerSignUpForm.returnEvent, sourceEvent = _useMakerSignUpForm.sourceEvent, countryEvent = _useMakerSignUpForm.countryEvent, selectedProductCategory = _useMakerSignUpForm.selectedProductCategory, shouldCollectSecondaryProductCategory = _useMakerSignUpForm.shouldCollectSecondaryProductCategory, numberStoresEvent = _useMakerSignUpForm.numberStoresEvent;
    var _useMakerSignUp = useMakerSignUp(), countryDropdownOption = _useMakerSignUp.countryDropdownOption, displaySource = _useMakerSignUp.displaySource, onBackClick = _useMakerSignUp.onBackClick, toggleAcceptedTerms = _useMakerSignUp.toggleAcceptedTerms, shouldShowSMSOptIn = _useMakerSignUp.shouldShowSMSOptIn;
    return {
        companyName: companyName,
        countryLabel: countryLabel,
        countryDropdownOption: countryDropdownOption,
        setCountry: setCountry,
        url: url,
        email: email,
        categoryOption: categoryOption,
        stockists: stockists,
        numProducts: numProducts,
        displaySource: displaySource,
        onUrlBlur: onUrlBlur,
        errorFor: errorFor,
        urlValidationInProgress: urlValidationInProgress,
        isUrlValid: isUrlValid,
        onChange: onChange,
        onSubmit: onSubmit,
        onBackClick: onBackClick,
        brandNameEvent: brandNameEvent,
        acceptedTerms: acceptedTerms,
        toggleAcceptedTerms: toggleAcceptedTerms,
        shouldShowSMSOptIn: shouldShowSMSOptIn,
        emailEvent: emailEvent,
        categoryEvent: categoryEvent,
        setFormField: setFormField,
        returnEvent: returnEvent,
        sourceEvent: sourceEvent,
        countryEvent: countryEvent,
        secondaryCategoryOptions: secondaryCategoryOptions,
        selectedProductCategory: selectedProductCategory,
        shouldCollectSecondaryProductCategory: shouldCollectSecondaryProductCategory,
        numberStoresEvent: numberStoresEvent
    };
};
